export const queryString = () => {
  let _queryString = {};
  const _query = window.location.search.substr(1);
  const _vars = _query.split('&');
  _vars.forEach((v, i) => {
    const _pair = v.split('=');
    if (!_queryString.hasOwnProperty(_pair[0])) {
      _queryString[_pair[0]] = decodeURIComponent(_pair[1]);
    } else if (typeof _queryString[_pair[0]] === 'string') {
      const _arr = [
        _queryString[_pair[0]],
        decodeURIComponent(_pair[1])
      ];
      _queryString[_pair[0]] = _arr;
    } else {
      _queryString[_pair[0]].push(decodeURIComponent(_pair[1]));
    }
  });
  return _queryString;
};

export const intToHexString = (number) => {
  if (number > 2147483647) {
    const hexStr = number.toString(16).toUpperCase();
    const arrHexStr = hexStr.match(/../g);
    const hexID = arrHexStr.join("");
    return hexID.length > 12
      ? "00" + hexID
      : "0000" + hexID;
  } else {
    return number.toString()
  }
}

export const intToHexVersion = (number) => {
  if (number > 0) {
    const arr = [
      (number >> 24) & 0xFF,
      (number >> 16) & 0xFF,
      (number >> 8) & 0xFF,
      number & 0xFF
    ];
    return arr.join('.');
  } else {
    return "0.0.0";
  }
}

export const b64DecodeUnicode = (str) => {
  return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
    return '%' + (
    '00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}

export const timeConverter = (UNIX_timestamp) => {
  const a = new Date(UNIX_timestamp * 1000);
  const months = [
    'T1',
    'T2',
    'T3',
    'T4',
    'T5',
    'T6',
    'T7',
    'T8',
    'T9',
    'T10',
    'T11',
    'T12'
  ];
  const year = a.getFullYear();
  const month = months[a.getMonth()];
  const date = a.getDate();
  const hour = a.getHours();
  const min = a.getMinutes();
  const sec = a.getSeconds();
  const zeroH = hour > 9
    ? ''
    : '0';
  const zeroM = min > 9
    ? ''
    : '0';
  const zeroS = sec > 9
    ? ''
    : '0';
  const time = date + ' ' + month + ' ' + year + ' ' + zeroH + hour + ':' + zeroM + min + ':' + zeroS + sec;
  return time;
}

export const timeConverterSimple = (UNIX_timestamp) => {
  const a = new Date(UNIX_timestamp * 1000);
  const months = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12'
  ];
  const year = a.getFullYear();
  const month = months[a.getMonth()];
  const date = a.getDate();
  const hour = a.getHours();
  const min = a.getMinutes();
  const sec = a.getSeconds();
  const zeroH = hour > 9
    ? ''
    : '0';
  const zeroM = min > 9
    ? ''
    : '0';
  const zeroS = sec > 9
    ? ''
    : '0';
  const time = date + '/' + month + '/' + year + ' ' + zeroH + hour + ':' + zeroM + min + ':' + zeroS + sec;
  return time;
}

export const timeAgoVnFromSubtractTime = (secs) => {
  let minutes = secs / 60;
  secs = Math.floor(secs % 60);
  if (minutes < 1) {
    return secs + ' giây';
  }
  let hours = minutes / 60;
  minutes = Math.floor(minutes % 60);
  if (hours < 1) {
    return minutes + ' phút';
  }
  let days = hours / 24;
  hours = Math.floor(hours % 24);
  if (days < 1) {
    return hours + ' giờ';
  }
  let weeks = days / 7;
  days = Math.floor(days % 7);
  if (weeks < 1) {
    return days + ' ngày';
  }
  let months = weeks / 4.35;
  weeks = Math.floor(weeks % 4.35);
  if (months < 1) {
    return weeks + (' tuần');
  }
  let years = months / 12;
  months = Math.floor(months % 12);
  if (years < 1) {
    return months + ' tháng';
  }
  years = Math.floor(years);
  return years + ' năm';
}

export const timeAgoShortFromEpochTime = (epoch) => {
  let now = new Date();
  let utc_timestamp = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());
  let secs = (utc_timestamp / 1000) - epoch - 25200;
  Math.floor(secs);
  let minutes = secs / 60;
  secs = Math.floor(secs % 60);
  if (minutes < 1) {
    return (
      secs > 1
      ? secs + 's'
      : 'now');
  }
  let hours = minutes / 60;
  minutes = Math.floor(minutes % 60);
  if (hours < 1) {
    return minutes + 'm';
  }
  let days = hours / 24;
  hours = Math.floor(hours % 24);
  if (days < 1) {
    return hours + 'h';
  }
  let weeks = days / 7;
  days = Math.floor(days % 7);
  if (weeks < 1) {
    return days + 'd';
  }
  let months = weeks / 4.35;
  weeks = Math.floor(weeks % 4.35);
  if (months < 1) {
    return weeks + ('w');
  }
  let years = months / 12;
  months = Math.floor(months % 12);
  if (years < 1) {
    return months + 'month';
  }
  years = Math.floor(years);
  return years + 'y';
}

export const timeAgoVnShortFromEpochTime = (epoch) => {
  let now = new Date();
  let utc_timestamp = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());
  let secs = (utc_timestamp / 1000) - epoch - 25200;
  Math.floor(secs);
  let minutes = secs / 60;
  secs = Math.floor(secs % 60);
  if (minutes < 1) {
    const time = secs > 1
      ? secs + ' giây'
      : '1 giây'
    const inHours = true
    return {time, inHours}
  }
  let hours = minutes / 60;
  minutes = Math.floor(minutes % 60);
  if (hours < 1) {
    const time = minutes + ' phút'
    const inHours = true
    return {time, inHours}
  }
  let days = hours / 24;
  hours = Math.floor(hours % 24);
  if (days < 1) {
    const time = hours + ' giờ'
    const inHours = false
    return {time, inHours}
  }
  let weeks = days / 7;
  days = Math.floor(days % 7);
  if (weeks < 1) {
    const time = days + ' ngày'
    const inHours = false
    return {time, inHours}
  }
  let months = weeks / 4.35;
  weeks = Math.floor(weeks % 4.35);
  if (months < 1) {
    const time = weeks + ' tuần'
    const inHours = false
    return {time, inHours}
  }
  let years = months / 12;
  months = Math.floor(months % 12);
  if (years < 1) {
    const time = months + ' tháng'
    const inHours = false
    return {time, inHours}
  }
  years = Math.floor(years);
  const time = '' //years + ' năm'
  const inHours = false
  return {time, inHours}
}

export const convertUnixTimeToGMT0 = (unixTime) => {
  if (unixTime === null || unixTime === 0) {
    return null;
  } else {
    const gmt7Date = new Date(unixTime * 1000);
    const gmt0Date = new Date(gmt7Date.getFullYear(), gmt7Date.getMonth(), gmt7Date.getUTCDate(), gmt7Date.getUTCHours(), gmt7Date.getMinutes());
    return gmt0Date;
  }
}

export const unixMinutesToHourString = (minutes) => {
  const hour = minutes / 60;
  const mi = Math.floor(minutes % 60);
  const padH = hour > 9
    ? ""
    : "0"
  const padM = mi > 9
    ? ""
    : "0"
  return `${padH}${hour}:${padM}${mi}`
}

export const unixToTime = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return hours * 60 + minutes
}

export const locdau = (str) => {
  let tempStr = str
  if (typeof str !== "undefined" && tempStr) {
    tempStr = tempStr.toLowerCase();
    tempStr = tempStr.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    tempStr = tempStr.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    tempStr = tempStr.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    tempStr = tempStr.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    tempStr = tempStr.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    tempStr = tempStr.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    tempStr = tempStr.replace(/đ/g, "d");
    //str= str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'| |\"|\&|\#|\[|\]|~|$|_/g,"-");
    /* tìm và thay thế các kí tự đặc biệt trong chuỗi sang kí tự - */
    //str= str.replace(/-+-/g,"-"); thay thế 2- thành 1-
    tempStr = tempStr.replace(/^-+|-+$/g, "");
    //cắt bỏ ký tự - ở đầu và cuối chuỗi
  }
  return tempStr
}

export const validatePhone = (phone) => {
  const re = /^(84|0)(1\d{9}|9\d{8})$/;
  return re.test(phone);
}

export const timeFormat = (timeStr) => {
  if (timeStr) {
    timeStr = timeStr.replace("T", " ")
    if (timeStr.indexOf("+") > 0) {
      var temp = timeStr.split("+")[0]
      timeStr = temp
    }
  }
  return timeStr
}

export const getDateConverterSimple = (UNIX_timestamp) => {
  const a = new Date(UNIX_timestamp * 1000);
  const months = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12'
  ];
  const year = a.getFullYear();
  const month = months[a.getMonth()];
  const date = a.getDate();

  const time = year + '-' + month + '-' + date
  return time;
}



// WEBPACK FOOTER //
// ./src/utils/index.js